<template>
	<section>
		<compFormEdit class="margin-layout" ref="formbase" :formdata="getBase" v-model="formData"></compFormEdit>
		<div class="text-right">
			<vButton
				class="margin-10"
				theme="primary"
				@click="save"
			>{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
			<vButton class="margin-10" @click="close">{{$t('global.common.close',{defaultValue:'关闭'})}}</vButton>
		</div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import mixin from "./mixin";
import { HttpUpdateProductPick, HttpProductManage } from '@/service/setting';
export default {
	props: ['params'],
    mixins: [mixin],
	data() {
		return {
			loading: false,
			formData: {
				id: this.params,
				pickDifficulty: 1.0,
				isVogue: '0',
                palletWarehousing: 0
			},
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		getBase() {
			return [{
				label: this.$t('erp.product.pick_difficulty', { defaultValue: '拣货下架难度' }),
				key: "pickDifficulty",
				tag: 'vInputNumber',
				props: {
					min: 0,
					max: 999.99,
					precision: 2,
				},
				formItem:{
					tip:`<div class=color-error>${this.$t('erp.productmanage.attention_1', { defaultValue: '请填写0-999.99内的数值，最多保留2位小数' })}</div>`
				}
			}, {
				label: this.$t('erp.product.pick_tag', { defaultValue: '拣货标签' }),
				key: "isVogue",
				tag: 'vSelect',
				options: [{
					value: '0',
					label: this.$t('erp.product.novogue', { defaultValue: '非爆品' }),
				}, {
					value: '1',
					label: this.$t('erp.product.isvogue', { defaultValue: '爆品' }),
				}]
			}, {
				label: this.$t('erp.product.warehouse_difficulty', { defaultValue: '仓储费计费系数' }),
				key: "warehouseDifficult",
				tag: 'vInputNumber',
				props: {
					min: 0,
					max: 999.99,
					precision: 2,
				},
				formItem:{
					tip:`<div class=color-error>${this.$t('erp.productmanage.attention_1', { defaultValue: '请填写0-999.99内的数值，最多保留2位小数' })}</div>`
				}
			},
            {
                label: this.$t("erp.product.warehouse_is_pallet", { defaultValue: "入库是否已打托" }),
                key: "palletWarehousing",
                tag: "vSelect",
                options: this.getIsWarehousingPallet,
            }
			];
		},
	},
	methods: {
		getDetail() {
			this.loading = true;
			HttpProductManage({ id: this.params }).then(res => {
				const data = res.data || {};
				this.loading = false;
				this.formData = {
					id: this.params,
					pickDifficulty: data.pickDifficult || 0,
                    isVogue: data.isVogue || '0',
                    warehouseDifficult: data.warehouseDifficult || 0,
                    palletWarehousing: data.palletWarehousing || 0
				};
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		//更新
		async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpUpdateProductPick(this.formData).then(() => {
				this.close();
				this.$emit('on-confirm')
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		close() {
			this.$emit('on-close')
		}
	}
};
</script>
